import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "./cn";

export function Card({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <section className={cn("rounded-2xl border border-border bg-surface p-5", className)} {...props} />;
}

export function CardHeader({
  title,
  aside,
  id,
  className,
}: {
  title: ReactNode;
  aside?: ReactNode;
  id?: string;
  className?: string;
}) {
  return (
    <div className={cn("mb-3 flex flex-wrap items-baseline justify-between gap-2", className)}>
      <h2 id={id} className="text-[17px] font-bold">
        {title}
      </h2>
      {aside && <div className="text-[13px] text-muted">{aside}</div>}
    </div>
  );
}
